import React, { useEffect, useState } from "react";
import { useApiGet } from "../../../api/apiCall";
import { Link } from "react-router-dom";
import { getRecentNoticessUrl } from "../../../api/urls";
import { GlobalMenu, MessageBox } from "../../../ui_elements";
import { LandingModal } from "./containers";
import DOMPurify from "dompurify";
import HeroBig from "../../../assets/images/hero_landing_image_desktop.png";

import styles from "./styles.module.css";
import { ArrowUp } from "../../../assets/svgs";
const date = new Date();

const Home = () => {
	const [message, setMessage] = useState(true);
	const [modal, setModal] = useState(false);
	const handleCurrentLink = (linkObject, isPartTime = false) => {
		if (!linkObject) return;
		return {
			pathname: linkObject.invoicePath,
			state: { application: { ...linkObject, isPartTime: isPartTime } }
		};
	};

	const handleFormLink = (linkObject, isPartTime = false) => {
		if (!linkObject) return;
		return {
			pathname: linkObject.loginPath,
			state: { application: { ...linkObject, isPartTime: isPartTime } }
		};
	};

	const applicationCards = [
		{
			title: "NCE Programme",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Generate Invoice",
					onClick: () => handleCurrentLink(applicationForms.nce, false)
				},
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.nce)
				}
			]
		},
		{
			title: "Degree Programme",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.degree)
				}
			]
		},
		{
			title: "Degree Programme (Direct Entry)",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.degreeDe)
				}
			]
		},
		{
			title: "NCE Programme (Part-Time)",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Generate Invoice",
					onClick: () => handleCurrentLink(applicationForms.ncePartTime, true)
				},
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.ncePartTime, true)
				}
			]
		},
		{
			title: "Sandwich Programme",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Generate Invoice",
					onClick: () => handleCurrentLink(applicationForms.preNce)
				},
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.preNce)
				}
			]
		},
		{
			title: "PDE Programme",
			description:
				"Please select a link applicable to your needs from the categories below",
			links: [
				{
					label: "Generate Invoice",
					onClick: () => handleCurrentLink(applicationForms.pde)
				},
				{
					label: "Application Form",
					onClick: () => handleFormLink(applicationForms.pde)
				}
			]
		}
	];

	const applicationForms = {
		preNce: {
			applicationMode: "5",
			id: "5",
			name: "Sandwich APPLICATION",
			loginPath: "/pre_nce_login",
			invoicePath: "/generate_pre_nce_students_invoice"
		},
		nce: {
			applicationMode: "6",
			id: "6",
			name: "NCE APPLICATION",
			loginPath: "/nce_login",
			invoicePath: "/generate_nce_students_invoice"
		},
		ncePartTime: {
			applicationMode: "2",
			id: "2",
			name: "NCE APPLICATION",
			loginPath: "/nce_login",
			invoicePath: "/generate_nce_students_invoice"
		},
		degree: {
			applicationMode: "1",
			id: "1",
			name: "DEGREE APPLICATION",
			loginPath: "/degree_login",
			invoicePath: "/generate_degree_invoice"
		},
		pde: {
			applicationMode: "3",
			id: "3",
			name: "PDE APPLICATION",
			loginPath: "/pde_login",
			invoicePath: "/generate_pde_invoice"
		},
		degreeDe: {
			applicationMode: "4",
			id: "4",
			name: "DEGREE DIRECT ENTRY APPLICATION",
			loginPath: "/de_degree_login",
			invoicePath: "/generate_de_degree_invoice"
		}
	};
	const { data, isFetched } = useApiGet(getRecentNoticessUrl(), {
		keepPreviousData: true
	});

	useEffect(() => {
		if (isFetched) {
			setModal(true);
		}
	}, [isFetched]);

	const handleScroll = () => {
		window.scrollTo(0, document.body.scrollHeight);
	};

	return (
		<>
			{!data?.data || data?.data.length === 0 ? null : (
				<LandingModal
					data={data?.data}
					isOpen={modal}
					closeModal={() => setModal(false)}
				/>
			)}
			{!data?.data ||
			data?.data?.length === 0 ||
			message === false ? null : (
				<MessageBox
					openModal={() => setModal(true)}
					closeMessage={setMessage}
					title={data?.data[0]?.title}
					message={
						<div
							className={`d-flex align-items-baseline ${styles.message_body}`}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(
										data?.data[0]?.description.slice(0, 70)
									)
								}}
							/>
							<span>....</span>
						</div>
					}
				/>
			)}
			<GlobalMenu isLanding={"unAuthenticated"} />
			<main className={`${styles.container}`}>
				<div className={styles.firstCover}>
					<div className={styles.sectionsContainer}>
						<section className="d-flex justify-content-center w-100 justify-content-md-between align-items-center">
							<div>
								{/* {currentApplication ? (
							<div className={styles.notice}>
								<span>Notice</span>
								{`${currentApplication.name} is now open!`}
							</div>
						) : (
							<></>
						)} */}
								<h1>
									Welcome to Enugu State College of Education
									Portal
									<br />
								</h1>
								<p className="mb-4">
									Embark on a journey through the virtual
									doors of our Portal - Your Gateway to
									Knowledge, Excellence, and Boundless
									Opportunities!
								</p>
								<button
									onClick={handleScroll}
									className={styles.btn}
								>
									Learn more
								</button>
							</div>
							<div className={styles.landing_sect}>
								<div className={styles.desktop_landing_img}>
									<img src={HeroBig} alt="landing_img" />
								</div>
								<img
									src={HeroBig}
									alt="landing_img"
									className="mobile_landing_img"
								/>
							</div>
						</section>
					</div>
				</div>
			</main>
			<div className={styles.application_section_container}>
				<div className={`mb-2 ${styles.application_section_header}`}>
					<h2 className="pb-1 mb-1">Our Programmes</h2>
					<p>
						Explore a World of Learning Possibilities: Discover Our
						Diverse Academic Pathways
					</p>
				</div>
				<div className={styles.application_section_container_cards}>
					{applicationCards.map((card, index) => (
						<div key={index} className={styles.application_card}>
							<h3>{card.title}</h3>
							<p className="text-left mt-1">{card.description}</p>
							<div className={styles.cardLinks}>
								{card.links.map((link, idx) => (
									<Link key={idx} to={() => link.onClick()}>
										{link.label}
									</Link>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
			<footer
				className={`d-flex align-items-center justify-content-center mt-5 ${styles.home_footer}`}
			>
				<p>
					{`Copyright©️ ${date.getFullYear()} All rights reserved by Enugu State College of Education (Technical). Powered by Tenece`}
				</p>
				<div
					className={`${styles.fab} d-flex align-items-center justify-content-center`}
					onClick={() =>
						window.scrollTo({
							top: 0,
							behavior: "smooth"
						})
					}
				>
					<ArrowUp />
				</div>
			</footer>
		</>
	);
};

export default Home;

// const ApplicationCard = ({ handleCurrentLink, applicationForm }) => {
// 	return (
// 		<div className={styles.application_card}>
// 			<h3>{applicationForm?.name?.toLowerCase()} Program</h3>
// 			<p className="text-left mt-1">
// 				Please select a link applicable to your needs from the
// 				categories below
// 			</p>
// 			<div className={`${styles.cardLinks} `}>
// 				<Link to={() => handleCurrentLink(applicationForm.DIPLOMA)}>
// 					Generate Invoice
// 				</Link>
// 				<Link to="/diploma_login">Application Form</Link>
// 			</div>
// 		</div>
// 	);
// };
